import React from "react";

import classes from "./Convincing.module.css";
import ConvincingItem from "./ConvincingItem";

export default function Convincing() {
  return (
    <div className={classes.convincingContainer}>
      <ConvincingItem
        itemText={"מגוון עצום של פרחים, עציצים וזרים מעוצבים לכל מטרה"}
      />
      <ConvincingItem
        itemText={"מחירים תחרותיים במיוחד לחנויות פרחים ולעסקים בתחום"}
      />
      <ConvincingItem
        itemText={"שירות מהיר ואמין, כולל אספקת זרי פרחים באיכות גבוהה"}
      />
      <ConvincingItem
        itemText={
          "ליווי אישי וייעוץ מקצועי בבחירת פרחים וזרי פרחים בהתאמה אישית"
        }
      />
      <ConvincingItem
        itemText={"עם ניסיון של למעלה מ-50 שנה באספקת פרחים טריים ואיכותיים"}
      />
    </div>
  );
}
